import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlPredio = '/service/basico/predio/'
class PredioService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getPredios() {
        return this.conex.get(urlPredio + 'predios/')
    }

    getUnidades() {
        return this.conex.get(urlPredio + 'unidadePredio/')
    }
}

export default PredioService
